// extracted by mini-css-extract-plugin
export default {"certificatePopUp":"CertificatePopUp_certificatePopUp__0D192","image":"CertificatePopUp_image__UzP7a"};